// utils/axiosInstance.js
import axios from 'axios';

const BASE_URL =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Function to configure Bearer token
const setAuthToken = (token) => {
  if (token) {
    axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers['Authorization'];
  }
};

// Wrapper to handle requests with or without Bearer token
const apiRequest = async (url, method = 'GET', data = null, token = null) => {
  try {

    const userToken = localStorage.getItem("userToken");
    // Set token if provided
    setAuthToken(userToken);

    // Make the request
    const response = await axiosInstance({
      url,
      method,
      data,
    });

    return response.data;
  } catch (error) {
    // Handle error (e.g., logging or rethrowing)
    console.error('API Request error:', error.response?.data || error.message);
    throw error; // Rethrow or handle accordingly
  }
};

export { axiosInstance, apiRequest, setAuthToken };